export default __webpack_public_path__ + "static/media/Warlord's Cinch.50424c93.jpg";